export default () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 2.5H3.33333C2.59695 2.5 2 3.09695 2 3.83333V13.1667C2 13.903 2.59695 14.5 3.33333 14.5H12.6667C13.403 14.5 14 13.903 14 13.1667V3.83333C14 3.09695 13.403 2.5 12.6667 2.5Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M4.66662 9.16445C4.29843 9.16445 3.99995 8.86597 3.99995 8.49778C3.99995 8.15589 4.25731 7.87411 4.58887 7.8356L4.66661 7.83112L11.3333 7.83562C11.7015 7.83562 12 8.1341 12 8.50229C12 8.84418 11.7426 9.12596 11.4111 9.16447L11.3333 9.16895L4.66662 9.16445Z"
      fill="white"
    />
  </svg>
);
